module.exports = __webpack_public_path__ + "static/media/hashtag.dad8d615.svg";